/**
 * Показ тегов на языке интерфейса.
 *
 * В базе лежат коды, а не текст: свободный ввод нельзя перевести, и
 * англоязычный игрок видел бы «города». Название берётся из справочника,
 * а если код в нём не нашёлся — показывается сам код: это заметно и чинится
 * модератором, в отличие от пустого места.
 */
import i18next from "i18next";

import type { Tag } from "../api/types";

export function tagName(tag: Tag | undefined, slug: string): string {
  if (!tag) return slug;
  return i18next.resolvedLanguage === "ru" ? (tag.nameRu ?? slug) : (tag.nameEn ?? slug);
}

/** Словарь по коду: списки тегов рисуются десятками, поиск по массиву дорог. */
export function tagIndex(tags: Tag[] | undefined): Map<string, Tag> {
  return new Map((tags ?? []).map((tag) => [tag.slug ?? "", tag]));
}
